import type { Axios } from 'axios'

import { GsResponse, RawResponse, toGsResponse } from '../goodstack'

import type { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'

export const disconnectCalendar: MutationFn<[string], GsResponse<{}>> = async (client: Axios, [provider]) => {
  const response = await client.delete<RawResponse<any>>(`/v1/giving-calendars/auth/disconnect/${provider}`, {
    withCredentials: true,
    validateStatus: status => status === 200 || status === 204
  })

  return toGsResponse(response.status, response.data)
}
